// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type HasLegacyInvoicesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HasLegacyInvoicesQuery = { allInvoices: { totalCount?: number | null } };

export const HasLegacyInvoicesDocument = gql`
    query HasLegacyInvoices {
  allInvoices(q: {includeLineItems: false}, page: {limit: 1, offset: 0}) {
    totalCount
  }
}
    ` as unknown as DocumentNode<HasLegacyInvoicesQuery, HasLegacyInvoicesQueryVariables>;
